var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNav5G(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 140",
    enableBackground: "new 0 0 512 140",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_x35_G_00000128454518404455197490000000498629785470972333_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.968,
    y1: 70,
    x2: 436.0847,
    y2: 70
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F34497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9845,
    style: {
      stopColor: "#7373FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7373FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_x35_G",
    fill: "url(#_x35_G_00000128454518404455197490000000498629785470972333_)",
    d: "M503.5,1.3C499,0.4,494.5,0,490.1,0 h-0.8c-25.4,0.1-45.6,13.9-49.3,26.2c0-7.1-21-5.4-16,7.9c-25.8,0-55.2,39.7-69.4,66.2c0,0-17.5-27.2-53.6-39.7 C265,48,211.4,73.8,187.3,100.3c0-6.6-13.3-13.2-19.6,0.5c-12-26-59.2-17.9-77.7-0.5c-2.3-15.4-10.2-35.6-27.3-48.3 C43.6,37.8,5.5,42.7,0,56.3V139l0.3,1h472.6H512V7.2C509.7,4.1,506.9,2,503.5,1.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav5G);
export default __webpack_public_path__ + "static/media/Nav-5G.cc2a5e65.svg";
export { ForwardRef as ReactComponent };